import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		myArticles: [],
	},
	mutations: {
		addArticle(state, article) {
			const alreadyAdded = state.myArticles.find(
				(art) => art.title[0].text === article.title[0].text
			);

			if (alreadyAdded) {
				alreadyAdded.quantity = alreadyAdded.quantity + article.quantity;
			} else {
				state.myArticles.push({ ...article, quantity: article.quantity });
			}
		},
		removeArticle(state, article) {
			const index = state.myArticles.indexOf(article);
			state.myArticles.splice(index, 1);
		},
		emptyCart(state) {
			state.myArticles = [];
		},
	},
	actions: {},
	modules: {},
});
